<p>blog works!</p>


<section class="blog-container">
    <article class="blog-post" *ngFor="let post of posts">
      <img [src]="post.image" alt="{{ post.title }}">
      <div class="post-details">
        <h2>{{ post.title }}</h2>
        <p class="post-date">{{ post.date | date: 'dd/MM/yyyy' }}</p>
        <p>{{ post.excerpt }}</p>
        <a [routerLink]="['/blog', post.id]" class="read-more-link">Leia mais</a>
      </div>
    </article>
  </section>
  